(() => {
  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', {
    style: 'currency', currency
  }).format((Number(cents) || 0) / 100);

  const emitCommerce = (eventName, detail = {}) => {
    const payload = {
      event: eventName,
      source: 'velisse_theme',
      event_id: `${eventName}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`,
      ...detail
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('velisse:commerce', { detail: payload }));
    return payload;
  };

  const productForm = document.querySelector('[data-velisse-product-form]');
  if (productForm && !productForm.hasAttribute('data-velisse-bundle-form')) {
    const variantsNode = document.getElementById('VelisseProductVariants');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const selectors = [...productForm.querySelectorAll('[data-option-position]')];
    const idInput = productForm.querySelector('[name="id"]');
    const addButton = productForm.querySelector('[data-add-to-cart]');
    const priceNodes = document.querySelectorAll('[data-current-price]');
    const variantNodes = document.querySelectorAll('[data-current-variant]');
    const inventoryNode = productForm.querySelector('[data-inventory-status]');
    const fulfilledUnitsInput = productForm.querySelector('[data-fulfilled-units]');
    const currency = productForm.dataset.currency || 'USD';
    const lowStockThreshold = Number(productForm.dataset.lowStockThreshold || 8);
    let activeVariant = variants.find((variant) => String(variant.id) === String(idInput?.value));

    const selectedOptions = () => selectors
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((selector) => selector.value);

    const syncVariant = () => {
      const options = selectedOptions();
      activeVariant = variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      if (!activeVariant) {
        addButton.disabled = true;
        addButton.textContent = 'Combination unavailable';
        inventoryNode.hidden = false;
        inventoryNode.textContent = 'This combination is not configured.';
        return;
      }
      idInput.value = activeVariant.id;
      priceNodes.forEach((node) => { node.textContent = money(activeVariant.price, currency); });
      variantNodes.forEach((node) => { node.textContent = activeVariant.title; });
      addButton.disabled = !activeVariant.available;
      addButton.textContent = activeVariant.available
        ? `Add to cart · ${money(activeVariant.price, currency)}`
        : 'Sold out';
      const quantity = Number(activeVariant.inventory_quantity);
      const showLowStock = activeVariant.inventory_management && quantity > 0 && quantity <= lowStockThreshold;
      inventoryNode.hidden = !showLowStock;
      inventoryNode.textContent = showLowStock ? `Only ${quantity} available in this option.` : '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', activeVariant.id);
      window.history.replaceState({}, '', url);
    };

    selectors.forEach((selector) => selector.addEventListener('change', () => {
      syncVariant();
      syncOfferCards();
    }));
    const packSelector = selectors.find((selector) => /pack|bundle|quantity/i.test(selector.name));
    const syncOfferCards = () => {
      if (!packSelector) return;
      document.querySelectorAll('[data-pack-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.packValue === packSelector.value));
        button.closest('[data-offer-card]')?.classList.toggle('selected', button.dataset.packValue === packSelector.value);
      });
    };
    document.querySelectorAll('[data-pack-value]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!packSelector) return;
        const requested = button.dataset.packValue;
        const option = [...packSelector.options].find((item) => item.value === requested || item.value.startsWith(requested.split(' ')[0]));
        if (!option) return;
        packSelector.value = option.value;
        packSelector.dispatchEvent(new Event('change', { bubbles: true }));
        syncOfferCards();
        productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    productForm.addEventListener('submit', () => {
      if (!activeVariant) return;
      const fulfilledUnits = Number(fulfilledUnitsInput?.value || 1);
      emitCommerce('velisse_add_to_cart_intent', {
        content_id: String(activeVariant.id),
        product_id: String(productForm.dataset.productId || ''),
        value: activeVariant.price / 100,
        currency,
        quantity: fulfilledUnits,
        line_quantity: Number(productForm.querySelector('[name="quantity"]')?.value || 1),
        bundle_units: fulfilledUnits
      });
    });
    syncVariant();
    syncOfferCards();
    if (activeVariant) emitCommerce('velisse_view_content', {
      content_id: String(activeVariant.id),
      product_id: String(productForm.dataset.productId || ''),
      value: activeVariant.price / 100,
      currency
    });
  }

  document.querySelectorAll('[data-checkout-intent]').forEach((button) => {
    button.addEventListener('click', () => emitCommerce('velisse_initiate_checkout_intent', {
      value: Number(button.dataset.cartTotal || 0) / 100,
      currency: button.dataset.currency || 'USD'
    }));
  });

  window.VelisseCommerce = { emit: emitCommerce };
  const revealTargets = document.querySelectorAll('.section-head,.detail,.outfit-card,.pack,.mechanism-grid article');
  revealTargets.forEach((element) => element.classList.add('reveal'));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }), { threshold: 0.12 });
    revealTargets.forEach((element) => observer.observe(element));
  } else revealTargets.forEach((element) => element.classList.add('visible'));
})();
